import { Routes } from '@angular/router';
import { LoginPage } from './features/login/pages/login-page/login-page';
import { authGuard } from './core/guards/auth/auth-guard';
import { HomePage } from './features/dashboard/pages/home-page/home-page';
import { UserConfigComponent } from './features/user/pages/user-config/user-config';
import { roleGuard } from './core/guards/role/role-guard';
import { ErrorPage } from './shared/components/error/error-page/error-page';
import { MenuSystemConfigPage } from './features/menu-system/pages/menu-system-config-page/menu-system-config-page';
import {SystemConfig} from './features/system/pages/system-config/system-config';
import { ProfileConfigPage } from './features/perfil/pages/profile-config-page/profile-config-page';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginPage,
  },
  {
    path: 'menu',
    component: HomePage,
    canActivate: [authGuard],
  },
  {
    path: 'sistemas',
    component: SystemConfig,
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'user-config',
    component: UserConfigComponent,
    canActivate: [authGuard, roleGuard],
  },

  {
    path: 'sistemas',
    component: HomePage,
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'menu-system-config',
    component: MenuSystemConfigPage,
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'profile-config',
    component: ProfileConfigPage,
    canActivate: [authGuard, roleGuard],
  },

  {
    path: '**',
    redirectTo: 'error',
  },
  {
    path: 'error',
    component: ErrorPage,
  },
];
